import { useCallback, useState } from 'react';
import { useMusic24Capabilities } from '../hooks/useMusic24Capabilities';
import { isSocialPeriodLocked } from '../promote/socialPeriod';

/** The periods of the Fans screen, in days (design presave-subscriptions c1: 7d, 28d, 90d, 1y). */
export const FANS_PERIODS = [7, 28, 90, 365] as const;
export type FansPeriodDays = (typeof FANS_PERIODS)[number];

/** 28 days, or 7 days when the history window of the plan is shorter than 28 days (Free). */
export function defaultFansDays(historyDaysLimit: number): FansPeriodDays {
  return historyDaysLimit < 28 ? 7 : 28;
}

/**
 * The period of the Fans screen. It starts at 28 days (7 on Free). A period past the history
 * window of the plan cannot be picked: the picker disables it (design c1, c6).
 */
export function useFansPeriod() {
  const { historyDaysLimit } = useMusic24Capabilities();
  const [picked, setPicked] = useState<FansPeriodDays>();

  // A plan change can make the picked period too long. The default period is always permitted.
  const days =
    picked === undefined || isSocialPeriodLocked(picked, historyDaysLimit) ? defaultFansDays(historyDaysLimit) : picked;

  const setDays = useCallback(
    (next: FansPeriodDays) => {
      if (!isSocialPeriodLocked(next, historyDaysLimit)) {
        setPicked(next);
      }
    },
    [historyDaysLimit]
  );

  return { days, setDays, historyDaysLimit };
}
